import { ReloadOutlined } from "@ant-design/icons";
import { Button } from "antd";

export const ReLoadBtn = ({ icon, displayText = true, ...others }) => {
  return (
    <Button
      color="green"
      variant="solid"
      icon={!icon ? <ReloadOutlined /> : icon}
      {...others}
    >
      {displayText && "Actualizar"}
    </Button>
  );
};
